// extracted by mini-css-extract-plugin
export var customFontBodySizeMedium = "16px";
export var customFontSize16 = "16px";
export var customFontSizeLg = "18px";
export var customFontSizeNormal = "14px";
export var customFontSizeSubtitle = "44px";
export var customFontSizeTitle = "56px";
export var customFontSizeXl = "22px";
export var customFontSizeXs = "12px";
export var customFontSizeXxl = "30px";
export var customFontSizeXxs = "8px";
export var fontBold = "ProximaNovaBold";
export var fontFamilyBase = "-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\"";
export var fontFamilyMonospace = "SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace";
export var fontFamilySansSerif = "-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\"";
export var fontRegular = "ProximaNovaRegular";
export var fontSemiBold = "ProximaNovaSemiBold";